import { useEffect, useRef } from 'react';

export function useEventListener(eventType, callback, element = window, dependencies = []) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if(!element) return;

    const handler = (event) => callbackRef.current(event);

    if (typeof element === 'HTMLCollection') {
      for (let i = 0; i < element.length; i++) {
        element.item(i).addEventListener(eventType, handler);
      }

      return () => {
        for (let i = 0; i < element.length; i++) {
          element.item(i).removeEventListener(eventType, handler);
        }
      };
    } else {
      if (!element.addEventListener) return;
      element.addEventListener(eventType, handler);
      return () => element.removeEventListener(eventType, handler);
    }
  }, [eventType, element, ...dependencies]);
}